module.exports = __webpack_public_path__ + "static/img/aws.a8bd0ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/aws.svg
// module id = Ckog
// module chunks = 1